module.exports = __webpack_public_path__ + "img/VL_20_01.1de55cd6.png";